import { useAuth0 } from '@auth0/auth0-react'
import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'
import feathers from '../../services/feathers'

const Invitation = (props) => {
  const { logout } = useAuth0()
  const { key } = useParams()

  useEffect(() => {
    localStorage.setItem('invitationXtranstec', key)
    console.log('++++++++++++++++')
    console.log('INVITATION', key)
    console.log('++++++++++++++++')
    logOut()
    // eslint-disable-next-line
  }, [key])

  const logOut = async () => {
    localStorage.removeItem('user')
    localStorage.removeItem('logged')
    localStorage.removeItem('token')
    try {
      await feathers.authentication.logout()
    } catch (error) {
      console.error('App.js', error)
      localStorage.removeItem('feathers-jwt')
    }
    await logout()
  }

  return <ContentWrapper></ContentWrapper>
}

const ContentWrapper = styled.div``

export default Invitation
